// extracted by mini-css-extract-plugin
export default {"Paper":"ColorPickerInput_Paper__jEUm-","EndAdornmentIconWrapper":"ColorPickerInput_EndAdornmentIconWrapper__+TxxJ"};